import { toNumber } from 'lodash';
import { paths, TASK_PRIORITY } from '@common/types';

export type ColumnNames =
  | 'task'
  | 'category'
  | 'priority'
  | 'due_date'
  | 'status'
  | 'patient'
  | 'provider'
  | 'location'
  | 'assignment';

export interface ITaskTableEntry {
  id: string;
  task: string;
  category: string;
  program: string | null;
  priority: TASK_PRIORITY;
  due_date: string;
  status: string;
  patient: string;
  patient_dob: string;
  provider: string;
  provider_phone: string;
  location: string;
  location_operator?: string;
  assignment: string;
  assignment_type: string;
  last_updated_at: string;
  created_date: string;
  canvas_status: string;
}

export type ITaskTableFilters = Pick<
  NonNullable<paths['/task']['get']['parameters']['query']>,
  'sort_by' | 'sort_order' | 'page' | 'limit'
>;

interface IUseTaskTableProps {
  filters: ITaskTableFilters;
  setFilters: (newFilters: ITaskTableFilters) => void;
}

export const useTaskTable = ({ filters, setFilters }: IUseTaskTableProps) => {
  const { sort_order } = filters;

  const handleChangeOrder = (colName: ColumnNames) => {
    setFilters({
      ...filters,
      sort_by: colName,
      sort_order: sort_order === 'ASC' ? 'DESC' : 'ASC',
    });
  };

  const onPageIndexChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    setFilters({ ...filters, page: page + 1 });
  };

  const onPageSizeChange = (event: {
    target: {
      value: string;
    };
  }) => {
    setFilters({ ...filters, limit: toNumber(event.target.value), page: 1 });
  };

  return {
    handleChangeOrder,
    onPageIndexChange,
    onPageSizeChange,
  };
};
